(function(){
    'use strict';
    angular.module('app').controller('FleetDetailsController', FleetDetailsController);

    FleetDetailsController.$inject = [
        '$scope',
        'FleetService',
        '$routeParams',
        '$location',
        '$timeout',
        'toastr',
        'FleetVehiclesTableService',
        'ConfirmationModalFactory',
        'ViewChangeNotificationFactory',
        'Units',
        'hasDuplicate',
        '$rootScope',
        'ClientService',
        '$q'
    ];

    function FleetDetailsController(
        $scope,
        FleetService,
        $routeParams,
        $location,
        $timeout,
        toastr,
        FleetVehiclesTableService,
        ConfirmationModalFactory,
        ViewChangeNotificationFactory,
        Units,
        hasDuplicate,
        $rootScope,
        ClientService,
        $q
    ) {
        const vm = this;
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const toInactiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_FLEET_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.TO_FLEET_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const onRouteChange = $scope.$on('$routeChangeStart', function(event, next) {
            if(!vm.isViewMode && isChanged(vm.fleet, vm.fleetRaw)){
                viewConfirmation.getInstance().result.then(function (cond) {
                    if (cond) {
                        onRouteChange();
                        let nextRoute = next.$$route.originalPath;
                        if( _.contains(next.$$route.originalPath, ':') ){
                            nextRoute = nextRoute.split(':')[0];
                        }
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        });
        const deleteConf = new ConfirmationModalFactory({},{
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        vm.measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
        vm.fleetId = $routeParams.id;
        vm.fleet = {
            company: $rootScope.GlobalProfile.company
        };
        vm.fleetRaw = angular.copy(vm.fleet);
        vm.isViewMode = false;
        vm.fleetVehiclesTableData = null;
        vm.saveInProgress = false;

        vm.saveDetails = saveDetails;
        vm.changeStatus = changeStatus;
        vm.isUnique = isUnique;
        vm.searchForCompanies = searchForCompanies;
        vm.getPreviousRoute = getPreviousRoute;
        vm.deleteFleet = deleteFleet;
        (()=>{
            if($routeParams.id) {
                vm.isFetching = true;

                FleetService.Fleets.get(vm.fleetId, function(result) {
                    const fleet = result;
                    getCompanyDetails(result.companyId).then(data=>{
                        fleet.company = data;
                    }).finally(()=>{
                        vm.isFetching = false;
                        getFleetVehicles(fleet.id);
                        vm.fleet = angular.copy(fleet);
                        vm.fleet.totalCapacity /= (1000000);
                        vm.fleetRaw = angular.copy(vm.fleet);
                    });
                }, function() {
                });
            }
        })();

        function searchForCompanies(select) {
            vm.companies =  [];
            if(!select.open){
                return false;
            }
            vm.searchingForCompany = true;
            ClientService.Company.getAll(
                function(data) {
                    vm.companies = data.content;
                    vm.searchingForCompany = false;
                }, function(err) {
                    vm.searchingForCompany = false;
                }, {
                    size:20,active: true, name: select.search
                });
        }

        function getPreviousRoute() {
            if($routeParams.vehicleId){
                return '/fleets/vehicles/details' + $routeParams.vehicleId;
            }
            if($routeParams.driverId){
                return '/fleets/drivers/details' + $routeParams.driverId;
            }
            return '../';
        }

        function getCompanyDetails(id) {
            const defer = $q.defer();
            if(!id){
                $timeout(()=>{
                    defer.resolve($rootScope.GlobalProfile.company);
                });
                return defer.promise;
            }
            ClientService.Company.get(id, function(data) {
                defer.resolve(data)
            }, function(err) {
                defer.resolve($rootScope.GlobalProfile.company);
            });

            return defer.promise;
        }

        function getFleetVehicles(fleetId) {
            vm.fleetVehiclesTableData = new FleetVehiclesTableService({
                exclude: ['type'],
                filter: {
                    ['fleet.id']: fleetId
                }
            }).tableData;
        }

        function changeStatus(evt) {
            evt.preventDefault();
            if(vm.fleet.active){
                vm.fleet.active = false;
                toActiveConf.getInstance().result.then(function (cond) {
                    if(cond) vm.fleet.active = true;
                });
                return false;
            }
            vm.fleet.active = true;
            toInactiveConf.getInstance().result.then(function (cond) {
                if(cond) vm.fleet.active = false;
            });
        }
        function cleanPayload(fleetDetais) {
            const {code, company, description, totalCapacity, name, active} = fleetDetais;
            return {
                code,
                companyId: company.id,
                description,
                totalCapacity: totalCapacity * 100,
                name,
                active,
                measureUnit: vm.measureUnit
            };
        }

        function isChanged(o, n) {
            return !angular.equals(cleanPayload(o), cleanPayload(n));
        }

        function saveDetails(form) {
            form.$setSubmitted();
            if(form.$invalid){
                return false;
            }
            vm.saveInProgress = true;
            if($routeParams.id){
                FleetService.Fleets.update(vm.fleetId, cleanPayload(vm.fleet), result=>{
                    vm.saveInProgress = false;
                    toastr.success('Data successfully updated');
                    vm.fleetRaw = angular.copy(vm.fleet);
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }else{
                FleetService.Fleets.create(cleanPayload(vm.fleet), result=>{
                    onRouteChange();
                    $location.path('/fleets/details/' + result.id);
                    toastr.success('Data successfully created');
                }, err=>{
                    vm.saveInProgress = false;
                    toastr.error(err.message);
                })
            }
        }
        function deleteFleet(fleet) {
            deleteConf.getInstance().result.then(cond=>{
                if(cond){
                    FleetService.Fleets.delete(fleet.id, data=>{
                        toastr.success('Fleet successfully deleted');
                        onRouteChange();
                        $location.path('/fleets');
                    }, err=>{
                        toastr.error('Unable to do request. Please try again later', err.message);
                    })
                }
            });
        }
        function isUnique(model) {
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.Fleets.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model,
                compareBy: 'code',
                raw: angular.getObjVal(vm, 'fleetRaw.code'),
                filters: {
                    size: 1,
                    code: model
                }
            }).then(res => {
                vm.codeError = res ? 'Fleet code is already taken' : null;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/FleetDetailsController.js